import React from "react";

import {LISTING_VENDOR_TEST_IDS} from "@pg-mono/test-ids";

import {ColumnListItem} from "../../../../../atoms/ColumnListItem";
import {OfferBox} from "../../../../components/offer_box/OfferBox";
import {OfferDisplayType} from "../../../../helpers/OfferDisplayType";
import {offerBoxTracking} from "../../../../tracking/offer_box_gtm_events";
import {IOfferListOffer} from "../../../../types/IOfferListOffer";
import {getOfferCardAddress, IOfferCardAddressContext} from "../../../../utils/get_offer_card_address";

interface IProps {
    offers: IOfferListOffer[];
    addressContext: IOfferCardAddressContext;
}

export const UnactiveOfferList = ({offers, addressContext}: IProps) => {
    return (
        <>
            {offers.map((offer, index) => {
                const isArchived = offer.configuration.display_type !== OfferDisplayType.FOR_SALE;
                const isUnavailable = !isArchived;
                return (
                    <ColumnListItem key={offer.id}>
                        <OfferBox
                            dataTestId={LISTING_VENDOR_TEST_IDS.PROPERTY_CONTAINER}
                            isArchived={isArchived}
                            isUnavailable={isUnavailable}
                            displayAddress={getOfferCardAddress(offer, addressContext)}
                            offer={offer}
                            index={index}
                            trackingMeta={{
                                listName: "Nieaktywne oferty",
                                listId: "nieaktywne_oferty",
                                source: "additional",
                                tileEvents: {
                                    imageClick: offerBoxTracking.gtm.investAdditionalImageClick,
                                    buttonClick: offerBoxTracking.gtm.investAdditionalButtonClick,
                                    linkClick: offerBoxTracking.gtm.investAdditionalLinkClick,
                                    logoClick: offerBoxTracking.gtm.investAdditionalLogoClick
                                }
                            }}
                        />
                    </ColumnListItem>
                );
            })}
        </>
    );
};
import React from "react";

import {LISTING_VENDOR_TEST_IDS} from "@pg-mono/test-ids";

import {ColumnListItem} from "../../../../../atoms/ColumnListItem";
import {OfferBox} from "../../../../components/offer_box/OfferBox";
import {OfferDisplayType} from "../../../../helpers/OfferDisplayType";
import {offerBoxTracking} from "../../../../tracking/offer_box_gtm_events";
import {IOfferListOffer} from "../../../../types/IOfferListOffer";
import {getOfferCardAddress, IOfferCardAddressContext} from "../../../../utils/get_offer_card_address";

interface IProps {
    offers: IOfferListOffer[];
    addressContext: IOfferCardAddressContext;
}

export const UnactiveOfferList = ({offers, addressContext}: IProps) => {
    return (
        <>
            {offers.map((offer, index) => {
                const isArchived = offer.configuration.display_type !== OfferDisplayType.FOR_SALE;
                const isUnavailable = !isArchived;
                return (
                    <ColumnListItem key={offer.id}>
                        <OfferBox
                            dataTestId={LISTING_VENDOR_TEST_IDS.PROPERTY_CONTAINER}
                            isArchived={isArchived}
                            isUnavailable={isUnavailable}
                            displayAddress={getOfferCardAddress(offer, addressContext)}
                            offer={offer}
                            index={index}
                            trackingMeta={{
                                listName: "Nieaktywne oferty",
                                listId: "nieaktywne_oferty",
                                source: "additional",
                                tileEvents: {
                                    imageClick: offerBoxTracking.gtm.investAdditionalImageClick,
                                    buttonClick: offerBoxTracking.gtm.investAdditionalButtonClick,
                                    linkClick: offerBoxTracking.gtm.investAdditionalLinkClick,
                                    logoClick: offerBoxTracking.gtm.investAdditionalLogoClick
                                }
                            }}
                        />
                    </ColumnListItem>
                );
            })}
        </>
    );
};
